import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 40px 0;

  ${up('sm')} {
    padding: 64px 0;
  }
`

const Intro = styled.div`
  padding: 30px 0 30px 0;

  ${up('sm')} {
    padding: 64px 0 64px 0;
  }
`

const Title = styled.h1`
  font-size: 26px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;

  ${up('sm')} {
    font-size: 26px;
    line-height: 30px;
  }
`

const UpdatedAt = styled.p`
  margin: 0;
  color: #0078c9;
  text-align: center;
`

const Section = styled.div`
  padding: 14px 0;

  ${up('sm')} {
    padding: 20px 0;
  }
`

const SectionTitle = styled.h6`
  margin-bottom: 18px;
  color: #22262a;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  text-transform: uppercase;

  ${up('sm')} {
    margin-bottom: 20px;
  }
`

const Statement = styled.p`
  color: #757d88;
  font-size: 16px;
  line-height: 28px;
  text-align: justify;

  :last-of-type {
    margin: 0;
  }
`

const Text = styled.p`
  margin-bottom: 32px;
  color: #22262a;
  font-size: 16px;
  line-height: 28px;
  text-align: justify;

  :last-of-type {
    margin: 0;
  }
`

export const ServicePolicy: ComponentType = () => (
  <Wrapper>
    <Container>
      <Row className="justify-content-center">
        <Col md={8}>
          <Intro>
            <Title>Política de Servicio</Title>
            <UpdatedAt>Actualizada a mayo 2022</UpdatedAt>
          </Intro>
        </Col>
        <Col md={8}>
          <Section>
            <Statement>
              Esta sección establece los términos y condiciones (en adelante, las “Condiciones Generales”) para el uso y navegación en el sitio web: www.yucatanpremier.com (en adelante, el “Sitio Web”). El Sitio Web y su contenido es propiedad de BIENES RAÍCES YUCATÁN PREMIER SA DE CV
            </Statement>
            <Statement>
              En caso de no estar de acuerdo con las Condiciones Generales, por favor, abandone el Sitio Web. La navegación por el usuario del Sitio Web se entenderá como aceptación plena y sin reservas de las Condiciones Generales aquí establecidas.
            </Statement>
            <Statement>
              En adelante, los términos “Usted” y “Usuario” serán utilizados para hacer referencia a todas las personas físicas y/o jurídicas que por cualquier razón accedan al Sitio Web.
            </Statement>
          </Section>
        </Col>
        <Col md={6}>
          <Section>
            <SectionTitle>1. ACCESO AL SITIO WEB</SectionTitle>
            <Text>
              El acceso y utilización del Sitio Web no requiere la previa suscripción o registro del Usuario. Sin embargo, es posible que en el futuro la utilización de algunos de los Servicios ofrecidos a través del Sitio Web requiera la suscripción o registro del Usuario y/o el pago de un precio.
            </Text>
          </Section>
          <Section>
            <SectionTitle>2. USO DEL SITIO WEB</SectionTitle>
            <Text>
              El Usuario se compromete a utilizar el Sitio Web de conformidad con estas Condiciones Generales, las leyes aplicables y con la moral y buenas costumbres.
            </Text>
            <Text>
              El Usuario se obliga a abstenerse de utilizar el Sitio Web con multas o efectos ilícitos, contrarios a lo establecido en las Condiciones Generales, lesivos de los derechos e intereses de terceros, o que de cualquier forma puedan dañar, inutilizar, sobrecargar o deteriorar el Sitio Web o impedir la utilización normal del Sitio Web por parte de los Usuarios.
            </Text>
          </Section>
          <Section>
            <SectionTitle>3. CONTENIDO DEL SITIO WEB</SectionTitle>
            <Text>
              Los contenidos de este Sitio Web, tales como texto, información, gráficos, imágenes, logos, marcas, programas de computación, bases de datos, diseños, arquitectura funcional y cualquier otro material (en adelante, el “Contenido”) están protegidos por las leyes mexicanas, pero sin limitación, las leyes sobre derechos de autor, patentes, marcas modelos, de utilidad, diseños industriales y nombres de dominio.
            </Text>
            <Text>
              Todo el Contenido es propiedad de BIENES RAÍCES YUCATÁN PREMIER SA DE CV y/o de cualquier otra sociedad vinculada y/o de sus proveedores de contenido. La compilación, interconexión, operatividad y disposición de los contenidos del Sitio Web es de propiedad exclusiva de BIENES RAÍCES YUCATÁN PREMIER SA DE CV y/o de sus empresas vinculadas. El uso, adaptación, reproducción y/o comercialización no autorizado del Contenido puede encontrarse penalizado por la legislación vigente.
            </Text>
          </Section>
          <Section>
            <SectionTitle>4. PROHIBICIONES</SectionTitle>
            <Text>
              Usted no copiará ni adaptará el código de programación desarrollado por, o por cuenta de, BIENES RAÍCES YUCATÁN PREMIER SA DE CV para generar y operar sus páginas, el cual se encuentra protegido por la legislación aplicable y vigente.
            </Text>
            <Text>
              Los Usuarios tienen prohibido utilizar el Sitio Web para transmitir, distribuir, almacenar o destruir cualquier tipo de material.
            </Text>
            <Text>
              Los Usuarios tienen prohibido violar o intentar violar la seguridad del Sitio Web. Las violaciones de la seguridad del sistema o de la red constituyen delitos penales y pueden derivar en responsabilidades civiles. BIENES RAÍCES YUCATÁN PREMIER SA DE CV investigará los casos de violaciones a la seguridad del sistema, pudiendo dirigirse a la autoridad judicial o administrativa competente a los efectos de perseguir a los Usuarios involucrados en tales violaciones.
            </Text>
            <Text>
              BIENES RAÍCES YUCATÁN PREMIER SA DE CV se reserva el derecho de suspender, bloquear o dar de baja a cualquier Usuario que, a criterio exclusivo de BIENES RAÍCES YUCATÁN PREMIER SA DE CV, no cumpla con estas Condiciones Generales sin que ello genere derecho a resarcimiento alguno .
            </Text>
          </Section>
          <Section>
            <SectionTitle>5. DATOS PERSONALES DEL USUARIO. REGISTRO EN EL SITIO WEB.</SectionTitle>
            <Text>
              En caso de que alguna sección del Sitio Web requiera un registro de usuario, se le pedirá que aporte información cierta de identificación personal que quedará sujeta al aviso de privacidad de BIENES RAÍCES YUCATÁN PREMIER SA DE CV.
            </Text>
          </Section>
          <Section>
            <SectionTitle>6. VÍNCULOS A OTROS SITIOS</SectionTitle>
            <Text>
              El Sitio Web puede contener vínculos a otros sitios de Internet. BIENES RAÍCES YUCATÁN PREMIER SA DE CV no respalda los contenidos de estos sitios web ni es responsable del contenido de los sitios web de terceros y no tiene ninguna garantía relativa al contenido o su exactitud en estos sitios web de terceros. Si usted decide acceder a sitios web de terceras partes vinculadas, lo hace a su propio riesgo.
            </Text>
          </Section>
          <Section>
            <SectionTitle>7. GENERALIDADES</SectionTitle>
            <Text>
              Usted acepta mantener indemnizaciones a BIENES RAÍCES YUCATÁN PREMIER SA DE CV de y contra cualquier cargo, acción o demanda, que resulten del uso que Usted haga del Sitio Web, de los Contenidos y de los Servicios. Usted acepta y reconoce que la información publicada en el sitio es meramente referencial y no constituye ninguna oferta formal para la celebración de ningún acto jurídico en el que interviene BIENES RAÍCES YUCATÁN PREMIER SA DE CV.
            </Text>
            <Text>
              BIENES RAÍCES YUCATÁN PREMIER SA DE CV se reserva el derecho a modificar total o parcialmente estas Condiciones Generales en cualquier momento.
            </Text>
          </Section>
        </Col>
      </Row>
    </Container>
  </Wrapper>
)
